export const BUSINESS_LICENSE_TYPES = {
	NATIONAL_CARD: 'national_card',
	OTHERS: 'others',
};
